(() => {
  // A new key excludes the old scraped prices and hidden accessibility labels.
  const storageKey = 'glaskob_recently_viewed_v2';
  function read() {
    try {
      const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items.filter(item => item && typeof item.url === 'string' && /^\/products\/[a-z0-9%-]+$/i.test(item.url)) : [];
    } catch { return []; }
  }
  function init(section) {
    const grid = section.querySelector('[id^="RecentlyViewedGrid-"]');
    if (!grid) return;
    const info = document.querySelector('product-info[data-product-id]');
    const title = document.querySelector('.product__title h1');
    const image = document.querySelector('.product__media-item img, .product__media img');
    let items = read();
    if (info && title) {
      const item = {id: info.dataset.productId, url: location.pathname, title: title.textContent.trim(), image: image?.currentSrc || image?.src || ''};
      items = [item, ...items.filter(saved => saved.id !== item.id)].slice(0, 12);
      try { localStorage.setItem(storageKey, JSON.stringify(items)); } catch { /* Browsing works without storage. */ }
    }
    const visible = items.filter(item => String(item.id) !== section.dataset.productId).slice(0, Number(section.dataset.limit) || 4);
    grid.replaceChildren();
    visible.forEach(item => {
      const li = document.createElement('li'); li.className = 'grid__item';
      const link = document.createElement('a'); link.className = 'recently-viewed__card'; link.href = item.url;
      const media = document.createElement('div'); media.className = 'recently-viewed__card-media';
      if (/^https:\/\//.test(item.image)) {
        const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.loading = 'lazy'; img.width = 300; img.height = 300; media.append(img);
      }
      const body = document.createElement('div'); body.className = 'recently-viewed__card-body';
      const name = document.createElement('p'); name.className = 'recently-viewed__card-title'; name.textContent = item.title;
      const cta = document.createElement('p'); cta.className = 'recently-viewed__card-price'; cta.textContent = section.dataset.linkLabel;
      body.append(name, cta); link.append(media, body); li.append(link); grid.append(li);
    });
    section.hidden = !visible.length;
  }
  document.querySelectorAll('.recently-viewed-section').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.recently-viewed-section').forEach(init));
})();
